module.exports = __webpack_public_path__ + "static/s2-3-nothing-d-83235b14a30dd25fab5e5dfc2b3a0ede.jpg";